import { CardIcon } from '@ui/icons/Card.icon'
import { IconFCType } from '@ui/icons/types'

import { CardType } from '@model/CardDetailsDto'

import { AmericanExpressCard } from '@assets/cards/AmericanExpress.card'
import { BCCard } from '@assets/cards/BC.card'
import { CartesBancairesCard } from '@assets/cards/CartesBancaires.card'
import { DenrsClubCard } from '@assets/cards/DenrsClub.card'
import { DiscoverCard } from '@assets/cards/Discover.card'
import { EloCard } from '@assets/cards/Elo.card'
import { HiperCard } from '@assets/cards/Hiper.card'
import { JCBCard } from '@assets/cards/JCB.card'
import { MasterCard } from '@assets/cards/Master.card'
import { TroyCard } from '@assets/cards/Troy.card'
import { UnionPayCard } from '@assets/cards/UnionPay.card'
import { VisaCard } from '@assets/cards/Visa.card'

const cardTypeDict: Record<CardType, IconFCType<{ background?: boolean }>> = {
  [CardType.Visa]: VisaCard,
  [CardType.Mastercard]: MasterCard,
  [CardType.Maestro]: MasterCard,
  [CardType.AmericanExpress]: AmericanExpressCard,
  [CardType.Discover]: DiscoverCard,
  [CardType.DinersClub]: DenrsClubCard,
  [CardType.CartesBancaires]: CartesBancairesCard,
  [CardType.Troy]: TroyCard,
  [CardType.BCCard]: BCCard,
  [CardType.Elo]: EloCard,
  [CardType.Hiper]: HiperCard,
  [CardType.HiperCard]: HiperCard,
  [CardType.JCB]: JCBCard,
  [CardType.UnionPay]: UnionPayCard,
  [CardType.Unknown]: CardIcon,
}

export const getCardByCardType = (cardType?: CardType) =>
  !cardType || !cardTypeDict[cardType] ? CardIcon : cardTypeDict[cardType]

const normalizeBtBrand = (brand?: string) => brand?.trim().toLowerCase()

export const btBrandToCardType = (brand?: string): CardType | undefined => {
  const b = normalizeBtBrand(brand)
  if (!b) return undefined

  switch (b) {
    case 'visa':
      return CardType.Visa
    case 'mastercard':
      return CardType.Mastercard
    case 'maestro':
      return CardType.Maestro
    case 'american-express':
    case 'amex':
      return CardType.AmericanExpress
    case 'diners-club':
    case 'dinersclub':
      return CardType.DinersClub
    case 'discover':
      return CardType.Discover
    case 'elo':
      return CardType.Elo
    case 'hiper':
      return CardType.Hiper
    case 'hipercard':
      return CardType.HiperCard
    case 'jcb':
      return CardType.JCB
    case 'unionpay':
      return CardType.UnionPay

    case 'cartes-bancaires':
    case 'cartesbancaires':
      return CardType.CartesBancaires

    case 'troy':
      return CardType.Troy
    case 'bc-card':
    case 'bccard':
    case 'bc':
      return CardType.BCCard

    default:
      return CardType.Unknown
  }
}

export const getCardIconByBtBrand = (brand?: string) => getCardByCardType(btBrandToCardType(brand))
